import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

export default class PageLoadingCircle extends Component {
  static propTypes = {
    open: PropTypes.bool,
  };

  render() {
    return (
        <div className={ classNames('loading-circle-wrapper', { open }) }>
          <div className='loading-circle'>
            <svg className='circular' viewBox='25 25 50 50'>
              <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='4' strokeMiterlimit='10' />
            </svg>
          </div>
        </div>

    );
  }

}
